import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  getAllAtmedBookingSurgery, getAtmedBookingSurgery,
} from '../../../store/actions';
import Booking from './booking';

const mapStateToProps = ({ vendorEquipmenReducer }) => ({
  results: vendorEquipmenReducer.results
});

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    getAllAtmedBookingSurgery,
    getAtmedBookingSurgery
  },
  dispatch,
);

export default connect(mapStateToProps, mapDispatchToProps)(Booking);
